module.exports = __webpack_public_path__ + "img/file-icon.c47eb2bf.svg";